/**
 * BaseFretebasEmpresa
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {BaseFretebasEmpresaCollection} from '@/model/collection/BaseFretebasEmpresaCollection'

/* TODO: review generated class */
export class BaseFretebasEmpresa extends Resource {
  idFretebasPk: number = 0

  empresa: string | null = null
  razaoSocial: string | null = null
  ramo: string | null = null
  tipo: string | null = null
  endereco: string | null = null
  nextel: string | null = null
  celular: string | null = null
  fone: string | null = null
  whatsup: string | null = null
  sac: string | null = null
  response: string | null = null

  get $id() {
    return this.idFretebasPk
  }
  set $id(val) {
    this.idFretebasPk = val
  }

  /**
   * Gets a instance of a given ID of BaseFretebasEmpresa
   */
  async getBaseFretebasEmpresa(id: number) {
    return await Request.get(`/admin/base-fretebas-empresa/${id}`)
      .name('getBaseFretebasEmpresa')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of BaseFretebasEmpresa
   */
  static async listBaseFretebasEmpresa(params: any) {
    return await Request.get(`/admin/base-fretebas-empresa`, {params})
      .name('listBaseFretebasEmpresa')
      .as(BaseFretebasEmpresaCollection)
      .getData()
  }

  /**
   * Persists a new instance of BaseFretebasEmpresa. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistBaseFretebasEmpresa() {
    return await Request.post(`/admin/base-fretebas-empresa`, this)
      .name('persistBaseFretebasEmpresa')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of BaseFretebasEmpresa to use it in a CSV file
   */
  static async listCsvBaseFretebasEmpresa(params: any) {
    return await Request.get(`/admin/base-fretebas-empresa/csv`, {params})
      .name('listCsvBaseFretebasEmpresa')
      .as(BaseFretebasEmpresaCollection)
      .getData()
  }
}
